// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    headingBlack1: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black 1",
        translatable: true
    },
    headingBlack2: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black 2",
        translatable: true
    },
    headingGradient: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Gradient",
        translatable: true
    },
    sectionSubtitle: {
        type: FIELD_TYPES.TEXT,
        label: "Section Subtitle",
        translatable: true
    },
    mainImage: {
        type: FIELD_TYPES.NESTED,
        label: "Main Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    workflowsLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Workflows Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    headingBlack1Visibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Heading Black 1 Visibility",
        translatable: false
    },
    headingBlack2Visibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Heading Black 2 Visibility",
        translatable: false
    },
    hideComponent: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Hide Component",
        translatable: false
    }
};
